import { Link } from "react-router-dom";

export const Logo = ({ compact = false }) => (
  <Link to="/" data-testid="brand-logo" className="flex items-center gap-2 group">
    <svg width={compact ? 28 : 34} height={compact ? 28 : 34} viewBox="0 0 40 40" className="shrink-0">
      <defs>
        <linearGradient id="lg-gold" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#F3D068" />
          <stop offset="1" stopColor="#8B6C15" />
        </linearGradient>
      </defs>
      <rect x="1" y="1" width="38" height="38" rx="4" fill="#090909" stroke="url(#lg-gold)" strokeWidth="1.5" />
      <text x="20" y="26" textAnchor="middle" fill="url(#lg-gold)" fontFamily="Outfit, sans-serif" fontWeight="900" fontSize="17" letterSpacing="1">PS</text>
    </svg>
    <div className="leading-none">
      <div className={`font-display font-black tracking-tight text-white group-hover:text-[#F3D068] transition-colors ${compact ? "text-base" : "text-xl"}`}>
        PULL STATION
      </div>
      <div className="text-[9px] font-mono-ps tracking-[0.28em] text-[#C9A227] uppercase mt-0.5 hidden sm:block">
        Your TCG Station
      </div>
    </div>
  </Link>
);
